import { render, staticRenderFns } from "./TeleMarketTypeConfig.vue?vue&type=template&id=b5c26f7a&scoped=true"
import script from "./TeleMarketTypeConfig.vue?vue&type=script&lang=js"
export * from "./TeleMarketTypeConfig.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketTypeConfig.vue?vue&type=style&index=0&id=b5c26f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c26f7a",
  null
  
)

export default component.exports